module.exports = __webpack_public_path__ + "img/paypal.357d634f.jpg";